import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  CircularProgress,
  TablePagination
} from '@mui/material';
import AdminApi from '../../Service/Admin.api';

const UserFeedbackList = () => {
  const [feedbacks, setFeedbacks] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    fetchFeedbacks();
  }, [page, pageSize]);

  const fetchFeedbacks = async () => {
    setLoading(true);
    try {
      const res = await AdminApi.getUserFeedbacks(page + 1, pageSize);
      if (res.success && res.data) {
        setFeedbacks(res.data.data || []);
        setTotalCount(res.data.totalCount || 0);
      }
    } catch (error) {
      console.error("Error fetching feedbacks:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold', color: '#1c234b' }}>
        User Feedback & Account Deletions
      </Typography>

      <Paper sx={{ width: '100%', overflow: 'hidden', borderRadius: 3, boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.05)" }}>
        {loading && feedbacks.length === 0 ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <TableContainer sx={{ maxHeight: 'calc(100vh - 270px)' }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f8fafc' }}>Date</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f8fafc' }}>User Details</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f8fafc' }}>Type</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f8fafc' }}>Reason</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f8fafc' }}>Comments</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {feedbacks.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                        <Typography color="text.primary">No feedbacks found.</Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    feedbacks.map((row) => (
                      <TableRow key={row.id} hover>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>
                          {formatDate(row.createdAt)}
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight="bold">{row.userName}</Typography>
                          <Typography variant="caption" color="text.primary" display="block">{row.email}</Typography>
                          <Typography variant="caption" color="text.primary">{row.phoneNumber}</Typography>
                        </TableCell>
                        <TableCell>
                          <Chip size="small" label={row.feedbackType} color={row.feedbackType === 'AccountDeletion' ? 'error' : 'default'} />
                        </TableCell>
                        <TableCell sx={{ maxWidth: 200 }}>
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>{row.reason || 'N/A'}</Typography>
                        </TableCell>
                        <TableCell sx={{ maxWidth: 300 }}>
                          <Typography variant="body2" color="text.primary" sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                          }}>
                            {row.comments || 'No comments provided'}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={pageSize}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[10, 25, 50]}
            />
          </>
        )}
      </Paper>
    </Box>
  );
};

export default UserFeedbackList;
